import {ContentContainer} from '@coolcolduk/ui-mui';
import {Box, CircularProgress, Paper, Typography} from '@mui/material';
import QuestionFilterDisplay from '../../../components/QuestionFilters/QuestionFilterDisplay';
import {PrivateRouteProps} from '../../../config/routeType';
import AdminQuestionReviewQuestionCount from './AdminQuestionReviewQuestionCount';
import AdminQuestionReviewQuestionDisplay from './AdminQuestionReviewQuestionDisplay';
import AdminQuestionReviewQuestionPageHeader from './AdminQuestionReviewQuestionPageHeader';
import useAdminQuestionReviewQuestion from './useAdminQuestionReviewQuestion';

export default function AdminQuestionReviewQuestionPage({user}: PrivateRouteProps) {
  const {
    filters,
    selectedAnswer,
    showFeedback,
    questionCount,
    currentQuestion,
    fetchLoading,
    countLoading,
    updateLoading,
    isAdmin,
    isReviewer,
    isCorrect,
    nextStep,
    sessionQuestion,
    handleAnswerSelect,
    handleSubmitAnswer,
    handleUpdateStatus,
    handleBack,
    handleReloadQuestion,
    handleNextQuestion,
    handlePrevQuestion,
    skipCount,
    examModules,
    questionId,
  } = useAdminQuestionReviewQuestion(user);

  return (
    <ContentContainer data-testid="admin-question-review-question-page">
      <AdminQuestionReviewQuestionPageHeader
        onBack={handleBack}
        onReloadQuestion={handleReloadQuestion}
        onNextQuestion={handleNextQuestion}
        onPrevQuestion={handlePrevQuestion}
        reloadLoading={fetchLoading}
        questionId={questionId}
        moduleId={filters.moduleId}
        question={currentQuestion}
        filters={filters}
        isAdmin={isAdmin}
        skipCount={skipCount}
      />

      <QuestionFilterDisplay filters={filters} examModules={examModules} />

      <AdminQuestionReviewQuestionCount count={questionCount} loading={countLoading} />

      {fetchLoading && (
        <Box sx={{display: 'flex', justifyContent: 'center', p: 4}}>
          <CircularProgress />
        </Box>
      )}

      {!fetchLoading && currentQuestion && (
        <AdminQuestionReviewQuestionDisplay
          question={currentQuestion}
          selectedAnswer={selectedAnswer}
          showFeedback={showFeedback}
          isCorrect={isCorrect}
          nextStep={nextStep}
          updateLoading={updateLoading}
          isAdmin={isAdmin}
          isReviewer={isReviewer}
          sessionQuestion={sessionQuestion}
          onAnswerSelect={handleAnswerSelect}
          onSubmitAnswer={handleSubmitAnswer}
          onUpdateStatus={handleUpdateStatus}
        />
      )}

      {!fetchLoading && !currentQuestion && (
        <Paper sx={{p: 3}}>
          <Typography variant="body1" color="text.secondary">
            No question found. Please go back and fetch a question.
          </Typography>
        </Paper>
      )}
    </ContentContainer>
  );
}
